import UpdateWordCloudView from './UpdateWordCloudView';
import './UpdateWordCloudView.scss';

export default UpdateWordCloudView;
